<template>
  <div class="FiveMedium">

    <h1><i class="fa fa-hand-peace-o" aria-hidden="true"></i> DAS 5MEDIUM EXPERIMENT</h1>

    <section class="fees">
      Fee to post: <span>{{ newThreadEther() }}</span> ethers<br>
      Fee to reply: <span>{{ newReplyEther() }}</span> ethers
    </section>

    <section class="explanations">
      <strong>What is this?</strong> It's a <a href="https://ethereum.stackexchange.com/questions/383/what-is-a-dapp" target="_blank">DAPP</a> (for Decentralized Application). It lives on the <img src="https://i.imgur.com/ypBYD0o.png"><strong>ethereum blockchain</strong> meaning that nothing is stored in a database. Isn't that incredible? To post a thread or reply to a post you will need a compatible wallet like <a href="https://github.com/ethereum/mist" target="_blank">Mist</a> or <a href="https://metamask.io/" target="_blank">Metamask</a>
    </section>

    <section class="warning">
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Warning: there is <strong>NO</strong> moderation. People can post anything and you might get shocked. Images and Videos are enabled by default, <button type="button" @click="nsfwFilter = !nsfwFilter">click here</button> to disable them.
    </section>


    <div class="alert" v-show="alert">Your post was successfuly posted. It might take some time until your transaction is confirmed. If you are using Metamask, you might have to reload the page to see the change.</div>

    <button type="button" class="post_thread" v-if="post_button" v-on:click="replyToThread();post_button = false; alert = false">post something</button>
    <form class="post_thread" v-else>
      <div class="nowallet" v-if="noWallet">
        You need to use a wallet to be able to post. Check <a href="" target="_blank">Metamask</a> or <a href="" target="_blank">Mist</a>.
      </div>
      <div v-else>
        <div v-if="activeAccount">
          <label for="account">your account</label>
          <select name="account" id="account" v-model="activeAccount">
            <option v-for="account in accounts">{{account}}</option>
          </select>

          <label for="image">your image</label>
          <input type="text" placeholder="http://image" id="form_image" name="image">

          <label for="text">your message</label>
          <textarea placeholder="your text" id="form_text" name="text"></textarea><br>

          <button type="button" class="post_thread_finish" v-on:click="post_thread">submit</button>
        </div>
        <div v-else>
          You need to connect your account to this DAPP. In Mist you can do it by clicking on "connect" in the upper right corner.
        </div>
      </div>
    </form>

    <nav>the last 20 active threads ⬇</nav>

    <section class="articles">
      <article v-for="thread in threads">
        <h2><i class="fa fa-hashtag" aria-hidden="true"></i> {{thread.timestamp}}</h2>

        <div class="postContent">
          <video preload="auto" autoplay="autoplay" muted="muted" loop="loop" v-if="thread.displayVideo && !nsfwFilter" webkit-playsinline>
            <source :src="thread.imageUrl" type="video/mp4">
          </video>
          <img :src="thread.imageUrl" v-else-if="thread.displayImage && !nsfwFilter" @error="noImage(thread.threadId, 0)">
          <p>{{thread.text}}</p>
        </div>

        <div class="replies">
          <div v-for="reply in thread.replies" class="reply">
            <h3><i class="fa fa-circle" aria-hidden="true"></i> {{reply.timestamp}}</h3>
            <div class="postContent">
              <video preload="auto" autoplay="autoplay" muted="muted" loop="loop" v-if="reply.displayVideo && !nsfwFilter" webkit-playsinline>
                <source :src="reply.imageUrl" type="video/mp4">
              </video>
              <img :src="reply.imageUrl" v-else-if="reply.displayImage && !nsfwFilter" @error="noImage(thread.threadId, reply.replyId)">
              <p>{{reply.text}}</p>
            </div>
          </div>

          <div class="alert_reply" v-show="thread.reply.alert">Your post was successfuly posted. It might take some time until your transaction is confirmed. If you are using Metamask, you might have to reload the page to see the change.</div>

          <template v-if="noWallet"></template>
          <template v-else>
            <form class="post_thread post_reply" v-if="thread.visibleReplyForm">
              <div class="nowallet" v-if="noWallet">
                You need to use a wallet to be able to post. Check <a href="" target="_blank">Metamask</a> or <a href="" target="_blank">Mist</a>.
              </div>
              <div v-else>
                <label for="account">your account</label>
                <select name="account" id="account" v-model="activeAccount">
                  <option v-for="account in accounts">{{account}}</option>
                </select>

                <label for="image">your image</label>
                <input type="text" placeholder="http://image" v-model="thread.reply.imageUrl" name="image">

                <label for="text">your message</label>
                <textarea placeholder="your text" v-model="thread.reply.text" name="text"></textarea><br>

                <button type="button" class="post_thread_finish" v-on:click="reply_thread(thread.threadId)">submit</button>
              </div>
            </form>
            <button class="reply-to-thread" @click="replyToThread(thread.threadId)" v-else>Reply to this thread</button>
          </template>



        </div>

      </article>
    </section>

    <footer>
      Created by <a href="/">David Wong</a>. Checkout this <a href="https://cryptologie.net/article/424/writing-a-dapp-for-the-ethereum-block-chain/" target="_blank">blogpost</a> for more information on the project.
    </footer>
  </div>
</template>

<script>
import Web3 from "web3";
import contractJSON from '../../../smart/build/contracts/FiveMedium.json';
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

//
// Vuex Store for threads and replies
// 

const store = new Vuex.Store({
  state: {
    threads: []
  },
  getters: {
    reversedThreads(state) {
        return state.threads.slice().reverse();
    }
  },
  mutations: {
    // Push a thread object into our dynamic list of threads 
    // (maxSize should be of 20 threads)
    pushToThreads (state, thread) {
      // debug
      console.log("adding thread to our threads:", thread)

      // check that the thread is not already there
      for(var i = 0; i < state.threads.length; i++) {
        if(state.threads[i].threadId == thread.threadId)
          return;
      }

      // TODO: is that secure?
      let imageUrl = thread.imageUrl;
      let displayImage = true;
      let displayVideo = false;
      if ((!imageUrl.startsWith('http') && !imageUrl.startsWith('data:')) || (imageUrl.search('goatse') != -1)) {
        displayImage = false;
      } else if (imageUrl.endsWith('.mp4')) {
        displayVideo = true;
      }
      
      // push
    //  console.log(thread)
      state.threads.push({
        timestamp: thread.timestamp,
        threadId: thread.threadId,
        text: thread.text,
        displayImage: displayImage,
        displayVideo: displayVideo,
        imageUrl: imageUrl,
        replies: thread.replies,
        visibleReplyForm: false,
        reply: {imageUrl:"", text:""}
      });

      // remove first (older) element 
      //  if we have more than 20 threads
      if(state.threads.length > 20) {
        state.threads.shift();
      }
    }, // end pushToThreads()

    // payload{threadId, reply{}}
    pushReply (state, payload) {

      // check that the reply is not already there
      for(var i = 0; i < state.threads.length; i++) 
      {
        if(state.threads[i].threadId == payload.threadId)
        {
          for(var j = 0; j < state.threads[i].replies.length; j++) 
          {
            if(state.threads[i].replies[j].replyId == payload.reply.replyId){
              return;
            }
          }
        }
      }

      // image?
      payload.reply.displayImage = true;
      payload.reply.displayVideo = false;
      if (!payload.reply.imageUrl.startsWith('http') && !payload.reply.imageUrl.startsWith('data:')) {
        payload.reply.displayImage = false;
      } else if (payload.reply.imageUrl.endsWith('.mp4')) {
        payload.reply.displayVideo = true;
      }
      
      // debug
      console.log("adding reply to thread:", payload.threadId, ":", payload.reply)
      // check that the thread is on the front page
      for(var i = 0; i < state.threads.length; i++) {
        if(state.threads[i].threadId == payload.threadId){
          state.threads[i].replies.push(payload.reply);
          return;
        }
      }
    } // end pushReply()
  } // end mutations {}
})

//
// FiveMedium Core
// 

function fetchReply(threadId, nextNode) {
  if(nextNode != 0) {
    contract.replies.call(nextNode, function (err, replyArray) {
      // reply object
      var reply = {
        replyId: nextNode,
        text: replyArray[0],
        imageUrl: replyArray[1],
        timestamp: replyArray[4].toNumber(),
      };
      store.commit('pushReply', {threadId:threadId, reply:reply});
      nextNode = replyArray[3].toNumber();
      fetchReply(threadId, nextNode);
    }); // end contract.replies()
  } // end if()
}

//
export default {
  name: 'FiveMedium',
  data () {
    return {
      feeNewThread: 0,    // fee to post thread
      feeReplyThread: 0,  // fee to reply to a thread
     
      post_button: true,  // button to post a message
      alert: false,
      
      noWallet: true,
      accounts: [],       // user accounts
      activeAccount: null, // the account to buy

      nsfwFilter: false,
    }
  },
  computed: {
    threads: () => {
      return store.getters.reversedThreads;
    },
  },
  methods: {
    noImage(threadId, replyId) {
      this.threads.forEach( (val) => {
        if(val.threadId === undefined) 
          return;
        if(val.threadId == threadId) {
          if(replyId == 0) {
            val.displayImage = false;
            return;
          }
          val.replies.forEach( (val2) => {
            if(val2.replyId == replyId){
              val2.replyId.displayImage = false;
              return;
            }
          })
        }
      })

    },
    replyToThread(threadId) {
      this.threads.forEach( (val) => {
        val.reply.alert = false;        
        if(val.threadId == threadId) {
          val.visibleReplyForm = true;
        } else {
          val.visibleReplyForm = false;
        }
      });
      this.post_button = true;

    },
    newThreadEther() {
      return new Web3().fromWei(this.feeNewThread, "ether")
    },
    newReplyEther() {
      return new Web3().fromWei(this.feeReplyThread, "ether")
    },

    reply_thread (threadId) {

      var text = '';
      var imageUrl = '';

      this.threads.forEach( (val) => {
        if(val.threadId == threadId) {
          text = val.reply.text
          imageUrl = val.reply.imageUrl
        }
      })

      contract.replyThread.sendTransaction(threadId, text, imageUrl, { value: this.feeReplyThread, from: this.activeAccount }, function(err, res) {

          if (err) {
            if (err.message && err.message.indexOf('User denied transaction signature.') !== -1)  {
              // Aborted, revert to original state.
              return;
            }
            console.log(err.toString());
            return;
          }

          console.log("success replying");
          this.replyToThread(); // hide form

          this.threads.forEach( (val) => {
            if(val.threadId == threadId) {
              val.reply.alert = true;
              val.reply.text = ''
              val.reply.imageUrl = ''
            }
          })

      }.bind(this));
    }, // end post_thread()

    post_thread (event) {
      var text = document.getElementById("form_text").value
      var imageUrl = document.getElementById("form_image").value

      contract.createThread.sendTransaction(text, imageUrl, { value: this.feeNewThread, from: this.activeAccount }, function(err, res) {

          if (err) {
            if (err.message && err.message.indexOf('User denied transaction signature.') !== -1)  {
              // Aborted, revert to original state.
              return;
            }
            console.log(err.toString());
            return;
          }

          console.log("success");
          this.alert = true;
          this.post_button = true;
          document.getElementById("form_image").value = "";
          document.getElementById("form_text").value = "";
      }.bind(this));
    }, // end post_thread()

  },
  mounted() {
    // different contract address for different networks
    var FiveMediumRinkebyAddress = "0x41e1Fc1E038560BF3E70509477097d450F1748D7";
    var FiveMediumLocalAddress = "0xac2ece9820e03fef74d3c66fd616d78edbdc70ca";
    var FiveMediumMainNetAddress = "0x470fb19D08c3d2eB8923A31d1408c393Dab09ccF";
    var debug = false;

    // by default we use the Rinkeby address
    var FiveMediumAddress = FiveMediumRinkebyAddress;

    // connect to network
    var FiveMediumAddress;
    if (typeof web3 !== 'undefined') { // wallet
      console.log("using the application's web3 version");
      window.web3 = new Web3(web3.currentProvider);
      this.noWallet = false;
    } else { 
      if(!debug) {  // no wallet
      console.log("using Infura web3");
//        window.web3 = new Web3(new Web3.providers.HttpProvider("https://rinkeby.infura.io/OOnNmO1GACWlnqKpps53"));
        window.web3 = new Web3(new Web3.providers.HttpProvider("https://mainnet.infura.io/OOnNmO1GACWlnqKpps53"));
      } else { // testing
        console.log("using local web3");
        window.web3 = new Web3(new Web3.providers.HttpProvider("http://localhost:8545"));
      }
    }

    // what network are we on?
    web3.version.getNetwork((err, netId) => {
      console.log("debug")
      switch (netId) {
        case "1":
          console.log('This is mainnet')
          FiveMediumAddress = FiveMediumMainNetAddress;
          break
        case "4":
          console.log("Using the Rinkeby test network");
          FiveMediumAddress = FiveMediumRinkebyAddress;
          break
        default:
          console.log('This is an unknown network:', netId);
          FiveMediumAddress = FiveMediumLocalAddress;
      }



      // get the user accounts
      web3.eth.getAccounts(function(err, accounts) {
        this.activeAccount = accounts[0]
        for (const account of accounts) {
          this.accounts.push(account);
        }
      }.bind(this));

      // get contract
      console.log("connected:", web3.currentProvider.isConnected())
      window.contract = Object.freeze(web3.eth.contract(contractJSON.abi).at(FiveMediumAddress));
      console.log("fetching contract at", FiveMediumAddress)

      // debug
      console.log("the contract interface:", contract.abi);

      // get public fees
       contract.feeNewThread.call( function(err, val) {
        this.feeNewThread = val.toNumber()
        console.log("setting feeNewThread to", this.feeNewThread)
      }.bind(this))
       contract.feeReplyThread.call( function(err, val) {
        this.feeReplyThread = val.toNumber()
       }.bind(this))

      // get 20 last threadIds 
      // TODO: this is async so it will be unsorted, change that by providing the "i" so that the store
      //       stores it under the right index in its array (of fixed 20 elements!!)
      console.log("retrieving last 20 threads");
      contract.indexLastThreads.call( function(err, val) { 
        var indexLastThreads = val.toNumber()
        console.log("indexLastThreads:", indexLastThreads);

        for(var i = 0; i < 20; i++) {
          try {

            // threadId = lastThreads[indexLastThreads]
            console.log("fetch threadId of indexLastThreads", indexLastThreads)
            contract.lastThreads.call(indexLastThreads, function(err, threadId) {
              threadId = threadId.toNumber();
              console.log("retrieved threadId", threadId);
              // check if these is something to fetch
              if(threadId == 0){
                return;
              }
              // threadArray = threads[threadId]
              contract.threads.call(threadId, function (err, threadArray) {

                // fetch replies
                var replies = [];
                var indexLastReply = threadArray[2].toNumber();
                var nextNode = threadArray[3].toNumber();

                fetchReply(threadId, nextNode);

                // push thread + replies to list
                var thread = {
                    threadId: threadId,
                    text: threadArray[0],
                    imageUrl: threadArray[1],
                    timestamp: threadArray[4].toNumber(),
                    replies: replies,
                  };
                store.commit('pushToThreads', thread);

              }.bind(this)); // end this.contract.threads()
             
            }.bind(this)); // end this.contract.lastThreads
           
          } catch(e) { // end of try {}
            continue;
          }

          // fetch next thread id (DESC)
          indexLastThreads = (indexLastThreads + 1) % 20;

        } // end for loop


      }.bind(this)) // end this.contract.indexLastThreads

      // watch new thread event
      const newThreadEvent = contract.newThreadEvent().watch( (error, newThread) => {
          console.log("newThreadEvent received.", newThread, error);
        if (!error) {
          var thread = {
            threadId: newThread.args.threadId.toNumber(),
            text: newThread.args.text,
            imageUrl: newThread.args.imageUrl,
            timestamp: newThread.args.timestamp.toNumber(), 
            replies: [],
          };
          store.commit('pushToThreads', thread);

        } // end if (!error)
      }); // end newThreadEvent.watch()

      // watch new reply event
      const newReplyEvent = contract.newReplyEvent().watch( (error, newReply) => {
        if (!error) {
          console.log("newReplyEvent received.", newReply);
          var replyTo = newReply.args.replyTo.toNumber();
          // reply object
          var reply = {
            replyId: newReply.args.replyId.toNumber(),
            text: newReply.args.text,
            imageUrl: newReply.args.imageUrl,
            timestamp: newReply.args.timestamp.toNumber(), 
          };
          store.commit('pushReply', {threadId:replyTo, reply:reply});

        } // end if (!error)
      }); // end newReplyEvent.watch()

      




    }) // end of web3.version.getNetwork()


  } // end async mounted()
} // end component
</script>

<style>

*{
  box-sizing:border-box;
}
.FiveMedium{
  display:flex;
  align-items: center;
  justify-content: center;
   flex-direction: column;
}
.FiveMedium .fees span{
  background-color:rgba(0,0,0,.1);
}
.FiveMedium .fees{
  text-align:left;
  margin-bottom:30px;
  line-height:30px;
  background-color:rgba(0,0,0,.05);
  border-round:5px;
  border-bottom:3px solid black;
  padding:5px;
  font-weight:400
}
.FiveMedium .articles{
}
.FiveMedium article{
  border:1px solid black;
  margin-bottom:10px;
  width:500px;
}
article img, article video{
  float:left;
  margin:0 10px 10px 0;
}
.replies{
  background-color:rgba(0,0,0,.05);
  padding:10px;
}

.post_thread{
  border:1px grey solid;
  margin:0 20%;
  padding:10px;
  line-height:35px;
}
.post_reply{
  border:0;
}
.post_thread label{
  display:block;
}
button.post_thread{
  background-color: rgba(8, 173, 59, 0.48);
  border:0;
  color:#0f5623;
  font-family:'source sans pro';
  font-weight:700;
  font-size:17px;
}
.alert{
  background-color: rgba(8, 173, 59, 0.48);
  padding:5px;
  margin-bottom:10px;
}
.post_thread textarea, .post_thread input, .post_thread select{
  border:0;
  font-size:14px;
  font-weight:300;
  background-color:rgba(0,0,0,.05);
  padding:5px;
  width:100%;

}
.post_thread_finish{
  display:block;
  margin:auto;
  background-color: rgba(8, 173, 59, 0.48);
  border:0;
  color:#0f5623;
  font-family:'source sans pro';
  font-weight:700;
  font-size:17px;
}

nav{
  margin:20px 0;
}
article h2{
  text-align:left;
  margin:0;
  padding:15px;
  font-size:17px;
}
article p{
  white-space: pre;
  white-space: pre-wrap;
  margin:0;
  padding:15px 15px 40px;
}
article h3{
  text-align:left;
  mragin:0;
  padding:0px 10px;
  font-size:13px;
}
.reply{
  border-bottom:1px dashed rgba(0,0,0,.2);
  margin-bottom:10px;
}
.reply:last-child{
  border:0;
}
article img, article video{
  max-width:40%;
}
.postContent{
  overflow:auto;
  padding:0 10px;
}
.explanations{
  background-color:rgba(249, 249, 12, 0.35);
  color:#3b4607;
  padding:15px;
  width:600px;
}
.explanations a{
  color:black;
  text-decoration:none;
  border-bottom:1px dashed rgba(0,0,0,.2);
  font-weight:400;
}
.warning{
  background-color:#ad2424;
  color:white;
  font-weight:600;
  padding:15px;
  margin-bottom:20px;
  width:600px;
}
.reply-to-thread{
  border:0;
  background:none;
  text-align:right;
  width:100%;
  display:block;
}
.alert_reply{
  margin-top:20px;
  font-weight:600;
}
footer{
  margin:20px 0;
}
footer a{
  text-decoration:none;
  border-bottom:1px black solid;
  color:black;
}



</style>





// WEBPACK FOOTER //
// src/components/FiveMediumForWallets.vue